<template>
  <BreadCrumb PageTitle="Modifier un virement" />
  <EditVirement  />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import EditVirement from "@/components/Virements/EditVirement.vue";

import { useRoute } from "vue-router";
export default defineComponent({
  name: "EditVirementPage",
  components: {
    BreadCrumb,
    EditVirement,
  },

  setup: () => {
    const route = useRoute();
    let id = route.params.id; 
    if (Array.isArray(id)) {
      id = id[0] ?? "";
    }

    let refNote = route.params.refNote; 
    if (Array.isArray(refNote)) {
      refNote = refNote[0] ?? "";
    }


    return { id , refNote};
}
});
</script>